import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import brands from "./brands.json";
import StoreProvider from "./store/StoreContext";
import NoFrame from "./NoFrame";

const brand = "M10";
document.documentElement.style.setProperty(
  "--data-color-primary",
  brands[brand].colors.primary
);
document.documentElement.style.setProperty(
  "--data-color-text",
  brands[brand].colors.text
);

// Won't render the application if WebApp is under Clickjacking attack
if(window.self === window.top) {
  ReactDOM.render(
    <React.StrictMode>
      <StoreProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </StoreProvider>
    </React.StrictMode>,
    document.getElementById("root")
  );
} else{
  ReactDOM.render(<NoFrame />, document.getElementById("root"));
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
